import handleAdjacentNode from '../helpers/handle-adjacent-node';
import { ARROW_KEYS } from '../constants/keys';

const keyUpHandler = (e) => {
  const { srcElement } = e;
  const isContentEditable = srcElement.hasAttribute('contenteditable');
  if (!isContentEditable) return;

  if (e.shiftKey && ARROW_KEYS.includes(e.key)) {
    handleAdjacentNode();
  }
};

export default keyUpHandler;
